module.exports = __webpack_public_path__ + "img/eSigns Logo Black.8d72467a.svg";